<template>
  <footer class="bg-primary">
    <cookie-law theme="base" buttonText="OK" class="ga-cookie-banner">
      <div slot="message">
        <p>{{ $t('gender app uses cookies') }}</p>
        <p>
          <router-link to="tos">{{ $t('read more in the') }} {{ $t('terms of service') }}</router-link>
        </p>
      </div>
    </cookie-law>
    <div class="gender-app-footer">
      <div class="text-center gender-app-footer__inner">
        <span class="gender-app-footer__text">gender app {{ new Date().getFullYear() }}</span>
        <span class="gender-app-footer__sep">·</span>
        <a class="gender-app-footer__social fab fa-instagram" href="https://instagram.com/gender_app" aria-label="Instagram"></a>
        <a class="gender-app-footer__social fab fa-facebook" href="https://www.facebook.com/genderapp" aria-label="Facebook"></a>
        <a class="gender-app-footer__social fab fa-patreon" href="https://www.patreon.com/genderapp" aria-label="Patreon"></a>
      </div>
    </div>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  name: 'GenderAppFooter',
  components: { CookieLaw }
}
</script>

<style scoped>
  .gender-app-footer {
    position: absolute;
    bottom: 1px;
    width: 100%;
  }

  .gender-app-footer__inner {
    padding: 0.45rem 0.75rem;
    font-size: 0.72rem;
    font-weight: 400;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.72);
  }

  .gender-app-footer__text {
    margin-right: 0.35rem;
  }

  .gender-app-footer__sep {
    margin: 0 0.35rem;
    opacity: 0.6;
  }

  .gender-app-footer__social {
    margin: 0 0.35rem;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.65);
    text-decoration: none;
  }

  .gender-app-footer__social:hover {
    color: rgba(255, 255, 255, 0.9);
  }
</style>
